import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import "../../Styles/Invoice.css";
import numberToWords from "../NumberToWords";
import Popup from "../Popup";
import { Helmet } from "react-helmet";
import config from "../../../config";
import { CircularProgress } from "@mui/material";
import { storage } from "../../../utils/firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Select from "react-select";
import jsPDF from "jspdf";
import { saveAs } from "file-saver";

function Invoice() {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  // const [membershipPrice, setMembershipPrice] = useState(0);
  const [invoiceDate, setInvoiceDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [popupMessage, setPopupMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const bid = localStorage.getItem("branch_id");
  const User_mobile_no = localStorage.getItem("mobile_no");

  const user = JSON.parse(localStorage.getItem("user"));
  const userType = user.type;
  const [showWhatsappConfirmation, setShowWhatsappConfirmation] =
    useState(false);
  const [whatsappData, setWhatsappData] = useState(null);

  const location = useLocation();
  const getCurrentDate = () => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const currentDate = new Date();
    const month = months[currentDate.getMonth()];
    const day = currentDate.getDate();
    const year = currentDate.getFullYear();

    return `${month} ${day}, ${year}`;
  };
  const uuid = location.state.uuid;
  //console.log("uuid", uuid);
  const isEditMode = location.state.isEditMode;

  const customer_name = location.state.customer_name;
  const mobile_no = location.state.mobile_no;
  const email = location.state.email;
  const services = location.state.GBselectedServices;
  const product = location.state.productData;
  //console.log("product ho tum", product);

  console.log("service ho tum", services);

  // //console.log("anaf",services)
  const isGST = services.length > 0 && services[0].gst === "Exclusive";

  // //console.log("servicessdklfjjka", isGST)

  const address = location.state.address;
  const service_by = location.state.GBselectedServices;
  const discount = location.state.discount;
  //console.log("discout h ye fgchvjk", discount);
  const gst_number = location.state.gst_number;
  const comments = location.state.comments;
  const invoiceId = location.state.InvoiceId;
  const payment_mode = location.state.paymentModes;
  const membership_points = location.state.deductedPoints || 0;
  const coupon_points = location.state.valueDeductedPoints || 0;
  const comboServicesDetail = location.state.comboServicesDetail || [];

  //console.log("serviess", service_by, services);
  const sname = localStorage.getItem("s-name");
  const [deductedPoint, setDeductedPoint] = useState(0);

  const initialPrices = services.map((service) =>
    parseFloat(service.finalPrice || service.inputFieldValue.price)
  );
  const [prices, setPrices] = useState(initialPrices);
  const initialQuantity = services.map((service) =>
    parseFloat(service.inputFieldValue.quantity)
  );
  const [quantities, setQuantities] = useState(initialQuantity);

  const token = localStorage.getItem("token");
  const coupon = location.state.selectedCoupons;
  // //console.log("coupon", coupon)

  // const [discounts, setDiscounts] = useState(
  //     Array(services.length).fill(discount)
  // );
  const [taxes, setTaxes] = useState(Array(services.length).fill(0));
  const [cgst, setCGST] = useState(
    Array(location.state.GBselectedServices.length).fill(0)
  );
  const [sgst, setSGST] = useState(
    Array(location.state.GBselectedServices.length).fill(0)
  );
  const [totalAmts, setTotalAmts] = useState(
    Array(location.state.GBselectedServices.length).fill(0)
  );

  const [total_prise, setTotalPrice] = useState(0);
  const [total_quantity, setTotalQuantity] = useState(0);
  const [total_discount, setTotalDiscount] = useState(0);
  const [total_tax, setTotalTax] = useState(0);
  const [total_cgst, setTotalCGST] = useState(0);
  const [total_sgst, setTotalSGST] = useState(0);
  const [grand_total, setGrandTotal] = useState(0);

  const [invoice, setInvoice] = useState([]);
  const [productPrice, setProductPrice] = useState(0);
  const [productDetails, setProductDetails] = useState([]);
  const [producData, setProductData] = useState(
    location.state?.productData || []
  ); // Default to empty array if not set
  

  const serviceDiscounts = services.map((item) =>
    parseFloat(item.discount || item.Discount || 0)
  );

  const productDiscountsvalue = product.map((item) => {
    const discount = item.discountValue || item.discount || 0;
    return typeof discount === "string" ? discount : String(discount);
  });

  const [discounts, setDiscounts] = useState(serviceDiscounts);
  const [productDiscounts, setProductDiscounts] = useState(
    productDiscountsvalue
  );
  const [productDiscountPercentages, setProductDiscountPercentages] = useState(
    product.map((item) => {
      const price = item.price;
      const discount = parseFloat(item.discount || item.discountValue || 0);
      const percent = price ? ((discount / price) * 100).toFixed(2) : "";
      return percent !== "0.00" ? percent : "";
    })
  );

  // For Products
  const handleProductDiscountPercentageChange = (index, value) => {
    const percentValue = parseFloat(value) || 0;
    const price = productDetails[index]?.price || producData[index]?.price || 0;
    const calculatedFlat = ((percentValue / 100) * price).toFixed(2);

    // Update percentage discounts
    const newPercentages = [...productDiscountPercentages];
    newPercentages[index] = value;
    setProductDiscountPercentages(newPercentages);

    // Update flat discounts
    const newDiscounts = [...productDiscounts];
    newDiscounts[index] = parseFloat(calculatedFlat);
    setProductDiscounts(newDiscounts);
  };

  const staffNames = service_by
    .map(
      (service) => service.staff.map((staffMember) => staffMember.label) // Returns an array of staff names
    )
    .flat();

  // //console.log("staff name", staffNames);

  const GST_RATE = 0.18; // 18% GST
  const CGST_RATE = GST_RATE / 2; // 9% CGST
  const SGST_RATE = GST_RATE / 2; // 9% SGST
  const roundToTwoDecimals = (num) => {
    if (isNaN(num) || num === undefined || num === null) {
      return 0;
    }
    return Number(num).toFixed(2); // Ensure num is a number and round to two decimals
  };
  // Your calculation functions
  const calculateTax = (price) => roundToTwoDecimals(price * GST_RATE);
  const calculateCGST = (price) => roundToTwoDecimals(price * CGST_RATE);
  const calculateSGST = (price) => roundToTwoDecimals(price * SGST_RATE);

  const apipoint = `${config.apiUrl}/api/swalook/inventory/product/?branch_name=${bid}`;

  const [rawProductData, setRawProductData] = useState([]);

  const productsWithStaff = product.map((item, index) => {
    const baseProduct = {
      id: String(item.id || ""),
      name: String(item.name || ""),
      price: String(item.price || "0"),
      quantity: String(item.quantity || "1"),
      discount: String(productDiscounts[index] || "0"),
      discountPercentage: String(productDiscountPercentages[index] || "0"),
      note: String(item.note || "No notes added"),
      category: String(item.category || ""),
      expiryDate: String(item.expiryDate || ""),
      unit: String(item.unit || ""),
      stock: String(item.stock || "0"),
    };

    const staffString = item.staff && Array.isArray(item.staff)
      ? item.staff
          .map((staffMember) => staffMember?.label ? String(staffMember.label) : "")
          .filter((name) => name)
          .join(", ")
      : "None";

    if (staffString === "") return { ...baseProduct, staff: "None" };

    return {
      ...baseProduct,
      staff: staffString || "None",
    };
  });

  // 1. Fetch product data from API
  useEffect(() => {
    const fetchProductData = async () => {
      const token = localStorage.getItem("token");

      try {
        const response = await axios.get(apipoint, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        });

        const productDatas = response?.data?.data || [];

        if (Array.isArray(productDatas)) {
          setRawProductData(productDatas); // 👈 Store raw product data
        } else {
          console.error("Unexpected response format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching product data:", error);
      }
    };

    fetchProductData();
  }, [apipoint]);

  // 2. Recalculate product details whenever productDiscounts or producData changes
  useEffect(() => {
    const updatedDetails = producData
      .map((pd, index) => {
        const product = rawProductData.find((p) => p.id === pd.id);
        if (product) {
          const price = Number(product.product_price) || 0;
          const quantity = Number(pd.quantity) || 0;
          const tax = Number(calculateTax(price)) || 0;
          const cgst = Number(calculateCGST(price)) || 0;
          const sgst = Number(calculateSGST(price)) || 0;
          const Discounts = productDiscounts[index] || 0;

          const total = price * quantity + tax + cgst + sgst;

          return {
            name: product.product_name,
            price: roundToTwoDecimals(price),
            quantity,
            Discounts,
            tax: roundToTwoDecimals(tax),
            cgst: roundToTwoDecimals(cgst),
            sgst: roundToTwoDecimals(sgst),
            total: roundToTwoDecimals(total),
          };
        }
        return null;
      })
      .filter(Boolean);

    setProductDetails(updatedDetails);
  }, [
    rawProductData,
    producData,
    productDiscounts,
    productDiscountPercentages,
  ]); // Add productDiscountPercentages to dependencies

  // Removed token from dependencies as it’s defined inside useEffect

  // Add dependencies for useEffect

  const Memebrship = location.state?.selectMembership;
  const membershipPrice = Memebrship.price || 0;
  const membership_name = Memebrship.program_type;
  const membergst = Memebrship.gst;
  const branchId = localStorage.getItem("branch_id");
  // const couponPrice = coupon.coupon_price || 0;
  // const coupon_name = coupon.coupon_name;
  // const couponTax = 0
  const isCouponGst = coupon.length > 0 && coupon[0].gst === "Exclusive";
  const quantity = coupon.length || 0;
  const totalCouponTax = coupon.reduce((acc, coupon) => {
    let couponTax = 0;
    if (coupon.gst === "Exclusive") {
      const couponCGST = coupon.coupon_price * CGST_RATE;
      const couponSGST = coupon.coupon_price * SGST_RATE;
      couponTax = couponCGST + couponSGST;
    }
    return acc + couponTax;
  }, 0);
  const coupon_tax = totalCouponTax / 2;
  const totalCouponGrandTotal = coupon.reduce((acc, coupon) => {
    let couponTax = 0;
    let couponTotal = coupon.coupon_price || 0;

    if (coupon.gst === "Exclusive") {
      const couponCGST = coupon.coupon_price * CGST_RATE;
      const couponSGST = coupon.coupon_price * SGST_RATE;
      couponTax = couponCGST + couponSGST;
      couponTotal += couponTax;
    }

    return acc + couponTotal;
  }, 0);
  const totalCouponPrice = coupon.reduce((acc, coupon) => {
    return acc + (coupon.coupon_price || 0);
  }, 0);

  // //console.log("kjfdsfhsj", coupon_tax)
  // const couponCGST = 0
  // const couponTotal = 0;
  // const couponSGST = 0;
  // if (coupongst === "Exclusive") {
  //    couponCGST = couponPrice * CGST_RATE;
  //    couponSGST = couponPrice * SGST_RATE;
  //   couponTax = couponCGST + couponSGST;
  //   couponTotal = couponPrice + couponTax;
  //   // // //console.log("sahil",membershipSGST,membershipCGST);
  // }

  useEffect(() => {
    const GST_RATE = 0.18;
    const CGST_RATE = GST_RATE / 2;
    const SGST_RATE = GST_RATE / 2;

    // Check if any service has "No GST"
    const noGSTApplied = services.some((service) => service.gst === "No GST");

    // Calculate taxes for services
    const updatedServiceTaxes = prices.map((price, index) => {
      const amountBeforeTax = price * quantities[index] - discounts[index];
      let taxAmount = 0;
      let cgstValue = 0;
      let sgstValue = 0;

      // Apply GST only if service does not have "No GST"
      if (services[index].gst !== "No GST") {
        taxAmount = amountBeforeTax * GST_RATE;
        cgstValue = taxAmount / 2;
        sgstValue = taxAmount / 2;
      }

      const totalAmt = parseFloat((amountBeforeTax + taxAmount).toFixed(2));

      return {
        taxAmount: parseFloat(taxAmount.toFixed(2)),
        cgstValue: parseFloat(cgstValue.toFixed(2)),
        sgstValue: parseFloat(sgstValue.toFixed(2)),
        totalAmt,
      };
    });

    const updatedProductTaxes = productDetails.map((product) => {
      const amountBeforeTax = product.price * product.quantity;
      let taxAmount = 0;
      let cgstValue = 0;
      let sgstValue = 0;
      let totalAmt = 0;

      // Apply taxes only if GST is applicable
      if (isGST) {
        taxAmount = amountBeforeTax * GST_RATE;
        cgstValue = taxAmount / 2;
        sgstValue = taxAmount / 2;
        totalAmt = amountBeforeTax + taxAmount;
      } else {
        taxAmount = 0;
        cgstValue = 0;
        sgstValue = 0;
        totalAmt = amountBeforeTax;
      }
      // //console.log("dvkdbv", totalAmt);
      // Total amount includes base price + tax if applicable
      return {
        taxAmount: parseFloat(taxAmount.toFixed(2)),
        cgstValue: parseFloat(cgstValue.toFixed(2)),
        sgstValue: parseFloat(sgstValue.toFixed(2)),
        totalAmt: parseFloat(totalAmt.toFixed(2)),
      };
    });

    let membershipTotal = Memebrship.price || 0;
    let membershipTax = 0;
    let membershipCGST = 0;
    let membershipSGST = 0;
    const isMemGst = membergst === "Exclusive";
    // Calculate GST values only if GST is applied
    if (membergst === "Exclusive") {
      const membershipCGST = Memebrship.price * CGST_RATE;
      const membershipSGST = Memebrship.price * SGST_RATE;
      membershipTax = membershipCGST + membershipSGST;
      membershipTotal = Memebrship.price + membershipTax;
      // // //console.log("sahil",membershipSGST,membershipCGST);
    }
    // Aggregate totals for services and products
    const totalServicePrices = prices.reduce(
      (acc, price, index) => acc + price * quantities[index],
      0
    );
    const totalServiceQuantity = quantities.reduce(
      (acc, quantity) => acc + quantity,
      0
    );
    const totalServiceDiscount = discounts.reduce(
      (acc, discount) => acc + discount,
      0
    );

    // Calculate totals for products
    const totalProductPrices = productDetails.reduce(
      (acc, product, index) => acc + product.price * product.quantity,
      0
    );
    const totalProductQuantity = productDetails.reduce(
      (acc, product) => acc + product.quantity,
      0
    );

    // Membership quantity to be added here
    const membershipQuantity = 1; // Change this to the actual membership quantity value
    const totalQuantity =
      totalServiceQuantity + totalProductQuantity + membershipQuantity;

    // Service totals
    const totalServiceTax = updatedServiceTaxes.reduce(
      (acc, { taxAmount }) => acc + taxAmount,
      0
    );
    const totalServiceCGST = updatedServiceTaxes.reduce(
      (acc, { cgstValue }) => acc + cgstValue,
      0
    );
    const totalServiceSGST = updatedServiceTaxes.reduce(
      (acc, { sgstValue }) => acc + sgstValue,
      0
    );
    const totalServiceGrandTotal = updatedServiceTaxes.reduce(
      (acc, { totalAmt }) => acc + totalAmt,
      0
    );
    // //console.log("false", isGST, isMemGst, isCouponGst)

    // Product totals
    const totalProductTax = updatedProductTaxes.reduce(
      (acc, { taxAmount }) => acc + taxAmount,
      0
    );
    const totalProductCGST = updatedProductTaxes.reduce(
      (acc, { cgstValue }) => acc + cgstValue,
      0
    );
    const totalProductSGST = updatedProductTaxes.reduce(
      (acc, { sgstValue }) => acc + sgstValue,
      0
    );
    const totalProductGrandTotal = updatedProductTaxes
      .map((item, i) => {
        const discount = productDiscounts[i] || 0;
        return item.totalAmt - discount;
      })
      .reduce((acc, val) => acc + val, 0);

    const productDiscount = Array.isArray(productDiscounts)
      ? productDiscounts.reduce((acc, d) => acc + (parseFloat(d) || 0), 0)
      : 0;

    // Final totals including membership
    const finalTotalPrice =
      totalServicePrices +
      totalProductPrices +
      membershipPrice +
      totalCouponPrice;
    const finalGrandTotal =
      totalServiceGrandTotal +
      totalProductGrandTotal +
      membershipTotal +
      totalCouponGrandTotal;

    // Update states
    setTotalPrice(finalTotalPrice.toFixed(2));
    setTotalQuantity(parseFloat(totalQuantity.toFixed(2)));
    setTotalDiscount(totalServiceDiscount + productDiscount);
    setTotalTax(
      (
        totalServiceTax +
        totalProductTax +
        membershipTax +
        totalCouponTax
      ).toFixed(2)
    );
    setTotalCGST((totalServiceCGST + totalProductCGST + coupon_tax).toFixed(2));
    setTotalSGST((totalServiceSGST + totalProductSGST + coupon_tax).toFixed(2));
    setGrandTotal(finalGrandTotal.toFixed(2));
    setTaxes(
      updatedServiceTaxes
        .map((t) => t.taxAmount)
        .concat(updatedProductTaxes.map((t) => t.taxAmount))
    );
    setCGST(
      updatedServiceTaxes
        .map((t) => t.cgstValue)
        .concat(updatedProductTaxes.map((t) => t.cgstValue))
    );
    setSGST(
      updatedServiceTaxes
        .map((t) => t.sgstValue)
        .concat(updatedProductTaxes.map((t) => t.sgstValue))
    );
    setTotalAmts(
      updatedServiceTaxes
        .map((t) => t.totalAmt)
        .concat(updatedProductTaxes.map((t) => t.totalAmt))
    );
  }, [
    prices,
    quantities,
    discounts,
    services,
    productDetails,
    Memebrship.price,
  ]);

  const handlePriceBlur = (index, value) => {
    const newPrices = [...prices];
    newPrices[index] = parseFloat(value);
    setPrices(newPrices);
  };

  const handleQuantityBlur = (index, value) => {
    const newQuantities = [...quantities];
    newQuantities[index] = parseFloat(value);
    setQuantities(newQuantities);
  };
  const [discountPercentages, setDiscountPercentages] = useState(
    services.map((item) => {
      const price = item.price;
      const discount = parseFloat(item.discount || item.Discount || 0);
      const percent = price ? ((discount / price) * 100).toFixed(2) : "";
      return percent !== "0.00" ? percent : "";
    })
  );

  const handleDiscountBlur = (index, value) => {
    const discountValue =
      value === null || value === undefined ? 0 : parseFloat(value);
    const newDiscounts = [...discounts];
    newDiscounts[index] = discountValue;
    setDiscounts(newDiscounts);

    const price = services[index]?.price || 0;
    const percent = price ? ((discountValue / price) * 100).toFixed(2) : "";
    const newPercentages = [...discountPercentages];
    newPercentages[index] = percent;
    setDiscountPercentages(newPercentages);
  };
  // For Services
  const handleDiscountPercentageChange = (index, value) => {
    const percentValue = parseFloat(value) || 0;
    const price = services[index]?.price || 0;
    const calculatedFlat = ((percentValue / 100) * price).toFixed(2);

    // Update percentage discounts
    const newPercentages = [...discountPercentages];
    newPercentages[index] = value;
    setDiscountPercentages(newPercentages);

    // Update flat discounts
    const newDiscounts = [...discounts];
    newDiscounts[index] = parseFloat(calculatedFlat);
    setDiscounts(newDiscounts);
  };
  const handleDiscountProduct = (index, value) => {
    const discountValue = parseFloat(value) || 0;
    const price = productDetails[index]?.price || producData[index]?.price || 0;
    const percent = price ? ((discountValue / price) * 100).toFixed(2) : "";

    setProductDiscounts((prev) => {
      const newDiscounts = [...prev];
      newDiscounts[index] = discountValue;
      return newDiscounts;
    });

    setProductDiscountPercentages((prev) => {
      const newPercentages = [...prev];
      newPercentages[index] = percent;
      return newPercentages;
    });
  };

  //console.log("productDiscounts", productDiscounts);

  const handleTaxBlur = (index, value) => {
    const newTaxes = [...taxes];
    newTaxes[index] = parseFloat(value);
    setTaxes(newTaxes);
  };

  const handleCGSTBlur = (index, value) => {
    const newCGST = [...cgst];
    newCGST[index] = parseFloat(value);
    setCGST(newCGST);
  };

  const handleSGSTBlur = (index, value) => {
    const newSGST = [...sgst];
    newSGST[index] = parseFloat(value);
    setSGST(newSGST);
  };

  const handleTotalAmtBlur = (index, value) => {
    const newTotalAmts = [...totalAmts];
    newTotalAmts[index] = parseFloat(value);
    setTotalAmts(newTotalAmts);
  };

  const [Minimum, setMinimum] = useState(0);

  useEffect(() => {
    const fetchAmount = async () => {
      const apiEndpoint = `${config.apiUrl}/api/swalook/loyality_program/get_minimum_value/?branch_name=${bid}`;
      try {
        const response = await axios.get(apiEndpoint, {
          headers: {
            Authorization: `Token ${localStorage.getItem("token")}`,
          },
        });
        if (response.data.status) {
          setMinimum(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchAmount();
  }, []);

  const bname = localStorage.getItem("branch_name");

  const final_price = Math.ceil(
    parseFloat(grand_total) -
      parseFloat(membership_points) -
      parseFloat(coupon_points)
  );

  const grandTotalInWords = numberToWords(
    final_price - membership_points - coupon_points
  );

  const [invoiceGenerated, setInvoiceGenerated] = useState(false);

  const handleGenerateInvoice = async (e) => {
    e.preventDefault();

    // Prevent duplicate submissions
    if (invoiceGenerated && totalPayment === final_price) {
      setPopupMessage(
        isEditMode
          ? "Invoice has already been updated"
          : "Invoice has already been generated"
      );
      setShowPopup(true);
      return;
    }

    setLoading(true);

const filteredServices = services.filter((service) => service.type !== "combo");

const newInvoice = filteredServices.map((service, index) => ({
  Description: service.name,
  category: service.category,
  Price: prices[index],
  Quantity: quantities[index],
  Discount: discounts[index],
  DiscountPercentage: discountPercentages[index] || 0,
  Tax_amt: taxes[index],
  Staff: staffNames[index],
  CGST: cgst[index],
  SGST: sgst[index],
  Total_amount: totalAmts[index],
}));

    // Prepare products data
    const productInvoice = productDetails.map((product, index) => ({
      Description: product.name,
      Price: product.price,
      Quantity: product.quantity,
      Discount: product.Discounts || 0,
      DiscountPercentage: productDiscountPercentages[index] || 0, // Add this line

      Tax_amt: product.tax,
      CGST: product.cgst,
      SGST: product.sgst,
      Total_amount: product.total - product.cgst - product.sgst,
    }));

    setInvoice(newInvoice);

    // Prepare payload
    const payload = {
      customer_name: customer_name,
      mobile_no: mobile_no,
      email: email,
      services: JSON.stringify(newInvoice),
      address: address,
      service_by: "",
      total_prise: total_prise,
      total_quantity: total_quantity,
      total_discount: total_discount,
      total_tax: total_tax,
      grand_total: final_price,
      total_cgst: total_cgst,
      total_sgst: total_sgst,
      gst_number: gst_number,
      comment: comments,
      slno: invoiceId,
      json_data: productsWithStaff,
      loyalty_points_deducted: deductedPoint,
      coupon_points_deducted: coupon,
      membership: Memebrship,
      coupon: coupon,
      new_mode: Object.keys(paymentModes).map((mode) => ({
        mode: mode,
        amount: paymentModes[mode],
      })),
      date: invoiceDate, // Add this line
      comboService: comboServicesDetail,
    };

    try {
      let response;
      const endpoint = `${config.apiUrl}/api/swalook/billing/`;

      if (isEditMode) {
        // PATCH request for update
        response = await axios.put(
          `${endpoint}?branch_name=${bid}&id=${uuid}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Token ${token}`,
            },
          }
        );
      } else {
        // POST request for create
        response = await axios.post(`${endpoint}?branch_name=${bid}`, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        });
      }

      // Handle success
      if (response.status >= 200 && response.status < 300) {
        await handlePrint();
        setPopupMessage(
          isEditMode
            ? "Invoice updated successfully"
            : "Invoice generated successfully"
        );
        setShowPopup(true);
        setInvoiceGenerated(true);
      }
    } catch (error) {
      setPopupMessage(
        isEditMode ? "Error updating invoice" : "Error generating invoice"
      );
      setShowPopup(true);
      console.error("API Error:", error);
      console.error("Response data:", error.response?.data);
    } finally {
      setLoading(false);
    }
  };

  // //console.log("service", service_by);

  const [getInvoiceId, setInvoiceId] = useState(invoiceId);

  const [getSaloonName, setSaloonName] = useState("");
  useEffect(() => {
    setSaloonName(localStorage.getItem("saloon_name"));
  });

  const branchName = localStorage.getItem("branch_name");
  // Calculate taxes and totals for the membership
  let membershipTotal = Memebrship.price;
  let membershipTax = 0;
  let cgsts = 9;
  let sgsts = 9;
  const isMemGst = membergst === "Exclusive";

  // Calculate GST values only if GST is applied
  if (membergst === "Exclusive") {
    cgsts = Memebrship.price * CGST_RATE;
    sgsts = Memebrship.price * SGST_RATE;
    membershipTax = cgsts + sgsts;
    membershipTotal = Memebrship.price + membershipTax;
    // //console.log("shjbfhbhgbefbehjbfhjdb", cgsts, sgsts);
  }

  const [paymentModes, setPaymentModes] = useState({});

  useEffect(() => {
    if (location.state?.paymentModes) {
      setPaymentModes(location.state.paymentModes);
    }
  }, [location.state]);

  const [selectedPayments, setSelectedPayments] = useState([]);
  const [amounts, setAmounts] = useState({});
  const options = [
    { value: "cash", label: "Cash" },
    { value: "upi", label: "UPI" },
    { value: "card", label: "Card" },
    { value: "net_banking", label: "Net Banking" },
    { value: "other", label: "Other" },
  ];

  const handleSelectChange = (selectedOptions) => {
    const updatedPayments = {};
    selectedOptions.forEach((option) => {
      updatedPayments[option.value] = paymentModes[option.value] || ""; // Preserve existing amount
    });
    setPaymentModes(updatedPayments);
  };
  const handleAmountChange = (mode, value) => {
    setPaymentModes((prev) => ({
      ...prev,
      [mode]: value, // Update the amount for the selected mode
    }));
  };

  const totalPayment = Object.values(paymentModes).reduce(
    (sum, amount) => sum + (parseFloat(amount) || 0),
    0
  );
  const handleSendInvoice = async (formData) => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${config.apiUrl}/api/swalook/save-pdf/`,
        formData,
        {
          headers: {
            Authorization: `Token ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      //console.log("PDF saved successfully", response.data);
    } catch (error) {
      console.error("Error saving PDF:", error);
    }
  };
  const handlePrint = async () => {
    try {
      // Build invoiceData
      const invoiceData = {
        sname,
        customer_name,
        address,
        email,
        mobile_no,
        getInvoiceId,
        invoiceDate,
        membership_points,
        services,
        productDetails,
        total_prise,
        total_discount,
        total_cgst,
        total_sgst,
        cgsts,
        sgsts,
        grand_total,
        final_price,
        gst_number,
        isGST,
        paymentModes,
      };
      // First, calculate the required height
      const calculateRequiredHeight = () => {
        let height = 50; // Start with base height for header and footer

        // Add height for services
        if (invoiceData.services?.length) {
          height += 10; // Section header
          invoiceData.services.forEach((s, index) => {
            height += 5; // Service line
            const discountPercent = discountPercentages[index] || 0;
            if (discountPercent > 0) {
              height += 5; // Discount line
            }
          });
        }

        // Add height for products
        if (invoiceData.productDetails?.length) {
          height += 10; // Section header
          invoiceData.productDetails.forEach((p, index) => {
            height += 5; // Product line
            const discountPercent = productDiscountPercentages[index] || 0;
            if (discountPercent > 0) {
              height += 5; // Discount line
            }
          });
        }

        // Add height for totals section
        height += 30; // Fixed height for totals section

        // Add buffer for safety
        height += 10;

        return Math.max(height, 200); // Minimum height of 150mm
      };

      const dynamicHeight = calculateRequiredHeight();

      const doc = new jsPDF({
        unit: "mm",
        format: [80, dynamicHeight], // Dynamic height based on content
      });

      let y = 5; // vertical cursor

      // Helpers
      const formatPrice = (price) => (Number(price) || 0).toFixed(2);
      const formatInvoiceDate = (dateStr) =>
        new Date(dateStr).toLocaleDateString("en-IN", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });

      // --- Header ---
      y += 5;
      doc.setFontSize(12).setFont(undefined, "bold");
      doc.text("INVOICE", 40, y, { align: "center" });
      y += 5;
      doc.setFontSize(9).setFont(undefined, "normal");
      doc.text("ORIGINAL FOR RECIPIENT", 40, y, { align: "center" });
      y += 5;

      // --- Business Info (Center Aligned) ---
      doc.setFontSize(11).setFont(undefined, "bold");
      doc.text(invoiceData.sname, 40, y, { align: "center" });
      y += 5;
      doc.text(invoiceData.address, 40, y, { align: "center" });

      doc.setFontSize(9).setFont(undefined, "normal");
      doc.text(`Phone: ${User_mobile_no}`, 40, y, {
        align: "center",
      });
      y += 6;

      // --- Invoice Meta (Mixed alignment like in the image) ---
      doc.setFontSize(9);

      // First line: Date (left) and something else (right) if needed
      doc.text("Date:", 4, y);
      doc.text(`${formatInvoiceDate(invoiceData.invoiceDate)}`, 72, y, {
        align: "right",
      });
      y += 5;

      // Bill No (left)
      doc.text("Bill No:", 4, y);
      doc.text(`${invoiceData.getInvoiceId}`, 72, y, { align: "right" });
      y += 5;

      // Client (left)
      doc.text("Client:", 4, y);
      doc.text(`${invoiceData.customer_name}`, 72, y, { align: "right" });
      y += 5;

      // Points (left)
      doc.text("Points:", 4, y);
      doc.text(`${invoiceData.membership_points || 0}`, 72, y, {
        align: "right",
      });
      y += 5;

      // Payment Mode (left)
      const paymentModesText = Object.entries(invoiceData.paymentModes || {})
        .filter(([_, amt]) => Number(amt) > 0)
        .map(([mode, amt]) => `${mode}(${formatPrice(amt)})`)
        .join(", ");
      doc.text("Payment Mode:", 4, y);
      doc.text(`${paymentModesText}`, 72, y, { align: "right" });
      y += 8;

      // --- Table Header ---
      doc.setFontSize(10).setFont(undefined, "bold");
      doc.text("Particulars", 4, y);
      doc.text("Price", 72, y, { align: "right" });
      y += 3;

      // Draw separator line
      doc.line(4, y, 76, y);
      y += 5;

      // --- Services ---
     if (invoiceData.services?.length) {
  doc.setFontSize(9).setFont(undefined, "bold");
  doc.text("Services", 4, y);
  y += 5;
  doc.setFont(undefined, "normal");

  invoiceData.services.forEach((s, index) => {
    const discountPercent = discountPercentages[index] || 0;
    const discountedPrice =
      discountPercent > 0
        ? s.price - (s.price * discountPercent) / 100
        : s.price;

    // Combine service name and sub-services
    const displayName = s.serviceNames
      ? `${s.name} (${s.serviceNames})`
      : s.name;

    // ✅ Auto-wrap long text
    const splitName = doc.splitTextToSize(displayName, 65); // wrap within 65 width units

    // Service name
    doc.text(splitName, 4, y);

    // Calculate how many lines this text took (for y spacing)
    const linesUsed = splitName.length;
    const textHeight = linesUsed * 5;

    // Price aligned to the right (aligned vertically with first line)
    doc.text(formatPrice(s.price), 72, y, { align: "right" });

    // Move down for next line
    y += textHeight;

    // ✅ Discount info (if any)
    if (discountPercent > 0) {
      doc.text(`-${discountPercent}%`, 4, y);
      doc.text(`- ${formatPrice(s.price - discountedPrice)}`, 40, y, {
        align: "center",
      });
      doc.text(formatPrice(discountedPrice), 72, y, { align: "right" });
      y += 5;
    }
  });
}


      // --- Products ---
      if (invoiceData.productDetails?.length) {
        doc.setFontSize(9).setFont(undefined, "bold");
        doc.text("Products", 4, y);
        y += 5;
        doc.setFont(undefined, "normal");

        invoiceData.productDetails.forEach((p, index) => {
          const discountPercent = productDiscountPercentages[index] || 0;
          const discountedPrice =
            discountPercent > 0
              ? p.price - (p.price * discountPercent) / 100
              : p.price;

          // Product name
          doc.text(p.name, 4, y);
          doc.text(formatPrice(p.price), 72, y, { align: "right" });
          y += 5;

          // Discount line if applicable
           if (discountPercent > 0) {
                        // Left: Discount percentage
                        doc.text(`-${discountPercent}%`, 4, y);
                        // Center: Discount amount
                        doc.text(
                            `- ${formatPrice(p.price - discountedPrice)}`,
                            40,
                            y,
                            { align: "center" }
                        );
                        // Right: Discounted price
                        doc.text(formatPrice(discountedPrice), 72, y, {
                            align: "right",
                        });
                        y += 5;
                    }
                });
      }

      // Draw separator line
      doc.line(4, y, 76, y);
      y += 5;

      // --- Totals ---
      doc.setFontSize(9);
      doc.text("Gross Total:", 4, y);
      doc.text(formatPrice(invoiceData.total_prise), 72, y, {
        align: "right",
      });
      y += 5;

      doc.text("Less Discount:", 4, y);
      doc.text(`-${formatPrice(invoiceData.total_discount)}`, 72, y, {
        align: "right",
      });
      y += 5;

      doc.text("Net Total:", 4, y);
      doc.text(
        formatPrice(invoiceData.total_prise - invoiceData.total_discount),
        72,
        y,
        { align: "right" }
      );
      y += 5;

      if (invoiceData.isGST) {
        doc.text(`CGST @${invoiceData.cgsts}%:`, 4, y);
        doc.text(formatPrice(invoiceData.total_cgst), 72, y, {
          align: "right",
        });
        y += 5;

        doc.text(`SGST @${invoiceData.sgsts}%:`, 4, y);
        doc.text(formatPrice(invoiceData.total_sgst), 72, y, {
          align: "right",
        });
        y += 5;
      }

      // Draw separator line
      doc.line(4, y, 76, y);
      y += 5;

      doc.setFontSize(10).setFont(undefined, "bold");
      doc.text("Total Payable:", 4, y);
      doc.text(formatPrice(invoiceData.grand_total), 72, y, {
        align: "right",
      });
      y += 4;
      // Draw separator line
      doc.line(4, y, 76, y);
      y += 5;

      // --- Receipt Note ---
      doc.setFontSize(9).setFont(undefined, "normal");
      doc.text("Payment Receipt: Total Received", 40, y, {
        align: "center",
      });
      y += 5;

      if (invoiceData.isGST) {
        doc.setFontSize(7);
        doc.text(`GSTN: ${invoiceData.gst_number}`, 40, y, {
          align: "center",
        });
        y += 5;
      }

      doc.setFontSize(7);
      doc.text("Powered by Swalook Global Pvt. Ltd.", 40, y, {
        align: "center",
      });

      // --- Save & Upload ---
      const blob = doc.output("blob");
      const fileName = `Invoice-${invoiceData.getInvoiceId}-thermal.pdf`;

      // Save locally
      saveAs(blob, fileName);

      // Upload to Firebase
      const pdfRef = ref(storage, `invoices/${fileName}`);
      await uploadBytes(pdfRef, blob);
      const downloadURL = await getDownloadURL(pdfRef);

      // WhatsApp link
      const phoneNumber = `+91${invoiceData.mobile_no}`;
      const reviewLink = localStorage.getItem("review_link");
      const googleReviewSection = reviewLink
        ? `
We truly value your feedback! Please take a moment to review us on Google:
${reviewLink}

`
        : "";

      const message = `Hello ${invoiceData.customer_name},

Thank you for your visit to ${invoiceData.sname} on ${new Date(
        invoiceData.invoiceDate
      ).toLocaleDateString("en-IN")}!

Here are your invoice details:

𝗣𝗿𝗼𝗱𝘂𝗰𝘁𝘀 & 𝗦𝗲𝗿𝘃𝗶𝗰𝗲𝘀: ${[
        ...(invoiceData.services?.map((s) => s.name) || []),
        ...(invoiceData.productDetails?.map((p) => p.name) || []),
      ].join(", ")}
𝗦𝘂𝗯𝘁𝗼𝘁𝗮𝗹: ₹${invoiceData.total_prise}
𝗗𝗶𝘀𝗰𝗼𝘂𝗻𝘁𝘀: ₹${invoiceData.total_discount}
𝗧𝗼𝘁𝗮𝗹 𝗣𝗮𝗶𝗱: ₹${invoiceData.final_price}
𝗣𝗮𝘆𝗺𝗲𝗻𝘁 𝗠𝗲𝘁𝗵𝗼𝗱: ${Object.entries(invoiceData.paymentModes || {})
        .map(([mode, amount]) => `${mode} (₹${amount})`)
        .join(", ")}
${
  coupon.length > 0
    ? `𝗖𝗼𝘂𝗽𝗼𝗻 𝗔𝗽𝗽𝗹𝗶𝗲𝗱: ${coupon.map((c) => c.coupon_name).join(", ")}`
    : ""
}
${
  Memebrship && membership_name !== "None"
    ? `𝗠𝗲𝗺𝗯𝗲𝗿𝘀𝗵𝗶𝗽 𝗜𝗻𝗳𝗼: ${membership_name}`
    : ""
}
𝗜𝗻𝘃𝗼𝗶𝗰𝗲 𝗡𝗼.: ${invoiceData.getInvoiceId}

Click here to download your invoice: ${downloadURL}

${googleReviewSection}Looking forward to welcoming you again!

— ${invoiceData.sname} Team`;
      // const message = `Hi ${invoiceData.customer_name}!\nWe hope you had a pleasant experience at ${invoiceData.sname}.\nYour total bill amount is: *Rs.${invoiceData.final_price}*\nWe are looking forward to servicing you again, attached is the invoice.\nThanks and Regards,\nTeam ${invoiceData.sname}\n\nClick on the link to download: ${downloadURL}`;
      const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
        message
      )}`;

      // Prepare formData with only essential details
      const formData = new FormData();
      formData.append("file", blob, fileName);
      formData.append("invoice", invoiceData.getInvoiceId);
      formData.append("customer_name", customer_name);
      formData.append("mobile_no", mobile_no);
      formData.append("email", email);
      formData.append("branch_name", sname);
      formData.append("pdf_url", downloadURL);
      formData.append("whatsapp_link", whatsappLink);
      formData.append("grand_total", grand_total);
      formData.append("invoice_date", invoiceDate);
      // Call handleSendInvoice with essential data only
      await handleSendInvoice(formData);

      setWhatsappData({
        blob,
        fileName,
        downloadURL,
        whatsappLink,
        invoiceData,
      });
      setShowWhatsappConfirmation(true);
    } catch (err) {
      console.error("Error generating jsPDF invoice:", err);
    }
  };
  const handleWhatsappConfirmation = (confirmed) => {
    setShowWhatsappConfirmation(false);
    if (confirmed && whatsappData) {
      // Open WhatsApp link if user confirmed
      window.open(whatsappData.whatsappLink, "_blank");
    }
  };
  return (
    <div className="invoice_container">
      <Helmet>
        <title>Invoice</title>
      </Helmet>

      <div className="bg-white p-6 shadow-lg rounded-3xl max-w-6xl mx-auto my-6">
        <form onSubmit={handleGenerateInvoice} className="space-y-6">
          {/* Header Section */}
          <div className="border-b-2 border-gray-200 pb-6">
            <div className="text-3xl font-bold text-gray-800 text-center">
              {sname}
            </div>
          </div>

          {/* Invoice Content */}
          <div className="flex flex-col md:flex-row gap-8">
            {/* Left Info */}
            <div className="bg-white p-6 rounded-3xl shadow-md w-full md:w-1/2 space-y-3">
              <h3 className="font-bold text-lg text-gray-900">Invoice To:</h3>
              <div className="space-y-1 text-gray-700">
                <p>{customer_name}</p>
                <p>{address}</p>
                <p>{email}</p>
                <p>{mobile_no}</p>
              </div>
              <p className="font-semibold pt-2">Payment Mode:</p>
              <div className="space-y-1">
                {Object.entries(paymentModes).map(([mode, amount]) => (
                  <p key={mode}>
                    <span className="font-semibold">{mode}:</span> {amount}
                  </p>
                ))}
              </div>
            </div>

            {/* Right Info */}
            <div className="bg-white p-6 rounded-3xl shadow-md w-full md:w-1/2 space-y-4">
              <div>
                <p className="font-semibold">Invoice Id:</p>
                <p>{getInvoiceId}</p>
              </div>
              <div>
                <p className="font-semibold">Date of Invoice:</p>
                {userType !== "staff" ? (
                  <>
                    <input
                      type="date"
                      value={invoiceDate}
                      onChange={(e) => setInvoiceDate(e.target.value)}
                      className="border border-gray-300 rounded-full px-4 py-2 w-full"
                    />
                  </>
                ) : (
                  <>
                    <input
                      type="date"
                      value={invoiceDate}
                      onChange={(e) => setInvoiceDate(e.target.value)}
                      className="border border-gray-300 rounded-full px-4 py-2 w-full"
                      readOnly
                    />
                  </>
                )}
              </div>
              {isGST && (
                <div>
                  <p className="font-semibold">
                    GST Number:{" "}
                    <span className="font-normal">{gst_number}</span>
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Table Section */}
          <div className="overflow-x-auto mt-6">
            <table className="min-w-full border border-gray-200 rounded-3xl overflow-hidden">
              <thead className="bg-blue-600 text-white">
                <tr>
                  <th className="p-3 border">S. No.</th>
                  <th className="p-3 border">DESCRIPTION</th>
                  <th className="p-3 border">PRICE</th>
                  <th className="p-3 border">QUANTITY</th>
                  <th className="p-3 border">DISCOUNT</th>
                  {(isGST || isMemGst || isCouponGst) && (
                    <>
                      <th className="p-3 border">TAX AMT (18%)</th>
                      <th className="p-3 border">CGST (9%)</th>
                      <th className="p-3 border">SGST (9%)</th>
                    </>
                  )}
                  <th className="p-3 border bg-blue-700">TOTAL AMT</th>
                </tr>
              </thead>
              <tbody>
                {(() => {
                  let currentSerial = 1;

                  return (
                    <>
                      {/* Services */}
                      {services.map((service, index) => (
                        <tr
                          key={`service-${index}`}
                          className="hover:bg-gray-50"
                        >
                          <td className="border p-3">{currentSerial++}</td>
                          <td className="border p-3">
                            {service.category}: {service.name}{" "}
                            {service.serviceNames}
                          </td>
                          <td className="border p-3">
                            <input
                              type="number"
                              className="w-full p-1 border rounded-full text-center"
                              value={prices[index]}
                              readOnly
                              onChange={(e) =>
                                handlePriceBlur(index, e.target.value)
                              }
                            />
                          </td>
                          <td className="border p-3">
                            <input
                              type="number"
                              className="w-full p-1 border rounded-full text-center"
                              value={quantities[index]}
                              readOnly
                              onBlur={(e) =>
                                handleQuantityBlur(index, e.target.value)
                              }
                            />
                          </td>
                          <td className="border p-3">
                            <div className="flex gap-2 w-full">
                              {/* Flat ₹ input */}
                              <div className="relative w-full">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none">
                                  ₹
                                </span>
                                <input
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  className="w-full pl-7 p-1 border rounded-full text-center"
                                  value={
                                    discounts[index] === 0
                                      ? ""
                                      : discounts[index] ?? ""
                                  }
                                  onChange={(e) => {
                                    let value = e.target.value;

                                    if (value.includes(".")) {
                                      const [intPart, decimalPart] =
                                        value.split(".");
                                      value =
                                        intPart + "." + decimalPart.slice(0, 2);
                                    }

                                    const newDiscounts = [...discounts];
                                    newDiscounts[index] =
                                      value === "" ? 0 : parseFloat(value);
                                    setDiscounts(newDiscounts);

                                    const price = services[index]?.price ?? 0;
                                    const percent = price
                                      ? (
                                          (newDiscounts[index] / price) *
                                          100
                                        ).toFixed(2)
                                      : "0";

                                    const newPercentages = [
                                      ...discountPercentages,
                                    ];
                                    newPercentages[index] = percent;
                                    setDiscountPercentages(newPercentages);
                                  }}
                                  placeholder="Rupees"
                                />
                              </div>

                              {/* Percentage input */}
                              <div className="relative w-full">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none">
                                  %
                                </span>
                                <input
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  max="100"
                                  className="w-full pl-7 p-1 border rounded-full text-center"
                                  value={
                                    Number(discountPercentages[index]) === 0
                                      ? ""
                                      : discountPercentages[index] ?? ""
                                  }
                                  onChange={(e) => {
                                    let value = e.target.value;

                                    if (value.includes(".")) {
                                      const [intPart, decimalPart] =
                                        value.split(".");
                                      value =
                                        intPart + "." + decimalPart.slice(0, 2);
                                    }

                                    if (parseFloat(value) > 100) {
                                      value = "100";
                                    }

                                    handleDiscountPercentageChange(
                                      index,
                                      value
                                    );
                                  }}
                                  placeholder="Percent"
                                />
                              </div>
                            </div>
                          </td>

                          {(isGST || isMemGst || isCouponGst) && (
                            <>
                              <td className="border p-3">{taxes[index]}</td>
                              <td className="border p-3">{cgst[index]}</td>
                              <td className="border p-3">{sgst[index]}</td>
                            </>
                          )}
                          <td className="border p-3 font-semibold">
                            {totalAmts[index]}
                          </td>
                        </tr>
                      ))}

                      {/* Membership */}
                      {Memebrship && membership_name !== "None" && (
                        <tr className="hover:bg-gray-50">
                          <td className="border p-3">{currentSerial++}</td>
                          <td className="border p-3">{membership_name}</td>
                          <td className="border p-3">
                            <input
                              type="number"
                              className="w-full p-1 border rounded-full text-center"
                              value={membershipPrice}
                              readOnly
                            />
                          </td>
                          <td className="border p-3 text-center">1</td>
                          <td className="border p-3 text-center">0</td>
                          {(isGST || isMemGst || isCouponGst) && (
                            <>
                              <td className="border p-3">{membershipTax}</td>
                              <td className="border p-3">{cgsts}</td>
                              <td className="border p-3">{sgsts}</td>
                            </>
                          )}
                          <td className="border p-3 font-semibold">
                            {isGST || isMemGst || isCouponGst
                              ? membershipTotal
                              : membershipTotal - membershipTax}
                          </td>
                        </tr>
                      )}

                      {/* Coupons */}
                      {coupon.map((couponItem, index) => {
                        const couponPrice = couponItem.coupon_price || 0;
                        const coupon_name = couponItem.coupon_name;
                        let couponCGST = 0,
                          couponSGST = 0,
                          couponTax = 0,
                          couponTotal = couponPrice;
                        if (couponItem.gst === "Exclusive") {
                          couponCGST = couponPrice * CGST_RATE;
                          couponSGST = couponPrice * SGST_RATE;
                          couponTax = couponCGST + couponSGST;
                          couponTotal = couponPrice + couponTax;
                        }
                        return (
                          <tr
                            key={`coupon-${index}`}
                            className="hover:bg-gray-50"
                          >
                            <td className="border p-3">{currentSerial++}</td>
                            <td className="border p-3">{coupon_name}</td>
                            <td className="border p-3">
                              <input
                                type="number"
                                className="w-full p-1 border rounded-full text-center"
                                value={couponPrice}
                                readOnly
                              />
                            </td>
                            <td className="border p-3 text-center">{quantity}</td>
                            <td className="border p-3 text-center">0</td>
                            {(isGST || isMemGst || isCouponGst) && (
                              <>
                                <td className="border p-3">
                                  {couponTax.toFixed(2)}
                                </td>
                                <td className="border p-3">
                                  {couponCGST.toFixed(2)}
                                </td>
                                <td className="border p-3">
                                  {couponSGST.toFixed(2)}
                                </td>
                              </>
                            )}
                            <td className="border p-3 font-semibold">
                              {isGST ||
                              membergst ||
                              couponItem.gst === "Exclusive"
                                ? couponTotal.toFixed(2)
                                : (couponTotal - couponTax).toFixed(2)}
                            </td>
                          </tr>
                        );
                      })}

                      {productDetails.map((product, index) => (
                        <tr
                          key={`product-${index}`}
                          className="hover:bg-gray-50"
                        >
                          <td className="border p-3">{currentSerial++}</td>
                          <td className="border p-3">{product.name}</td>
                          <td className="border p-3">
                            <input
                              type="number"
                              className="w-full p-1 border rounded-full text-center"
                              value={product.price}
                              readOnly
                            />
                          </td>
                          <td className="border p-3 text-center">
                            {product.quantity}
                          </td>
                          <td className="border p-3">
                            <div className="flex gap-2 relative w-full">
                              {/* Flat Discount Input (₹) */}
                              <div className="relative w-full">
                                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none">
                                  ₹
                                </span>
                                <input
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  className="w-full pl-7 p-1 border rounded-full text-center"
                                  value={
                                    Number(productDiscounts[index]) === 0
                                      ? ""
                                      : productDiscounts[index] ?? ""
                                  }
                                  onChange={(e) => {
                                    let value = e.target.value;

                                    if (value.includes(".")) {
                                      const [intPart, decimalPart] =
                                        value.split(".");
                                      value =
                                        intPart + "." + decimalPart.slice(0, 2);
                                    }

                                    const newDiscounts = [...productDiscounts];
                                    newDiscounts[index] =
                                      value === "" ? 0 : parseFloat(value);
                                    setProductDiscounts(newDiscounts);

                                    const price =
                                      productDetails[index]?.price ??
                                      producData[index]?.price ??
                                      0;

                                    const percent = price
                                      ? (
                                          (newDiscounts[index] / price) *
                                          100
                                        ).toFixed(2)
                                      : "";

                                    const newPercentages = [
                                      ...productDiscountPercentages,
                                    ];
                                    newPercentages[index] = percent;
                                    setProductDiscountPercentages(
                                      newPercentages
                                    );
                                  }}
                                  placeholder="Rupees"
                                />
                              </div>

                              {/* Percentage Discount Input (%) */}
                              <div className="relative w-full">
                                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none">
                                  %
                                </span>
                                <input
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  max="100"
                                  className="w-full pl-7 p-1 border rounded-full text-center"
                                  value={
                                    Number(
                                      productDiscountPercentages[index]
                                    ) === 0
                                      ? ""
                                      : productDiscountPercentages[index] ?? ""
                                  }
                                  onChange={(e) => {
                                    let value = e.target.value;

                                    if (value.includes(".")) {
                                      const [intPart, decimalPart] =
                                        value.split(".");
                                      value =
                                        intPart + "." + decimalPart.slice(0, 2);
                                    }

                                    // 🧱 Enforce 100% max
                                    if (parseFloat(value) > 100) {
                                      value = "100";
                                    }

                                    handleProductDiscountPercentageChange(
                                      index,
                                      value
                                    );
                                  }}
                                  placeholder="Percent"
                                />
                              </div>
                            </div>
                          </td>
                          {(isGST || isMemGst || isCouponGst) && (
                            <>
                              <td className="border p-3">{product.tax}</td>
                              <td className="border p-3">{product.cgst}</td>
                              <td className="border p-3">{product.sgst}</td>
                            </>
                          )}
                          <td className="border p-3 font-semibold">
                            {isGST || membergst
                              ? (
                                  product.total -
                                  product.cgst -
                                  product.sgst
                                ).toFixed(2)
                              : (
                                  product.total -
                                  product.tax -
                                  product.cgst -
                                  product.sgst -
                                  productDiscounts[index]
                                ).toFixed(2)}
                          </td>
                        </tr>
                      ))}

                      {/* Total Row */}
                      <tr className="bg-blue-50 font-semibold">
                        <td
                          colSpan="2"
                          className="border p-3 text-blue-700 text-center"
                        >
                          TOTAL
                        </td>
                        <td className="border p-3"></td>
                        <td className="border p-3 text-center">
                          {parseFloat(
                            Memebrship
                              ? total_quantity + quantity
                              : total_quantity + quantity - 1
                          ).toFixed(2)}
                        </td>
                        <td className="border p-3 text-center">
                          {Number(total_discount).toFixed(2)}
                        </td>

                        {(isGST || isMemGst || isCouponGst) && (
                          <>
                            <td className="border p-3">{total_tax}</td>
                            <td className="border p-3">{total_cgst}</td>
                            <td className="border p-3 ">{total_sgst}</td>
                          </>
                        )}
                        <td className="border p-3 text-blue-800 text-center">
                          ₹ {grand_total}
                        </td>
                      </tr>
                    </>
                  );
                })()}
              </tbody>
            </table>
          </div>

          {/* Comments */}
          {comments && (
            <div className="mt-6 p-4 bg-gray-100 rounded-xl">
              <h4 className="font-semibold text-gray-800">Comments:</h4>
              <p className="mt-1 text-gray-700">{comments}</p>
            </div>
          )}

          {/* Footer */}
          <div className="flex flex-col md:flex-row justify-between gap-6 mt-8">
            <div className="space-y-3">
              {membership_points > 0 && (
                <h4 className="font-semibold text-emerald-700">
                  Membership Points Discount:
                </h4>
              )}
              {coupon_points > 0 && (
                <h4 className="font-semibold text-emerald-700">
                  Coupon Points Discount:
                </h4>
              )}
              <h4 className="font-semibold text-gray-800">Amount in Words:</h4>
              <p className="text-gray-700">{grandTotalInWords} Rupees Only</p>
            </div>
            <div className="space-y-3 text-right">
              {membership_points > 0 && (
                <p className="text-red-500 font-bold">
                  - {membership_points} Points
                </p>
              )}
              {coupon_points > 0 && (
                <p className="text-red-500 font-bold">
                  - {coupon_points} Points
                </p>
              )}
              <h4 className="font-semibold text-gray-800">FINAL VALUE:</h4>
              <p className="text-2xl font-bold text-gray-900">
                Rs {final_price}
              </p>
            </div>
          </div>

          {/* Payment Mode Selection */}
          <div className="mt-8">
            <label className="block font-semibold mb-2">Mode of Payment</label>
            <Select
              isMulti
              isSearchable={false}
              options={options}
              className="w-full md:w-1/2"
              onChange={handleSelectChange}
              value={Object.keys(paymentModes).map((mode) => ({
                value: mode,
                label: mode.charAt(0).toUpperCase() + mode.slice(1),
              }))}
              placeholder="Select Payment Mode"
              required
            />
          </div>

          {/* Payment Table */}
          {Object.keys(paymentModes).length > 0 && (
            <div className="mt-6">
              <table className="w-full md:w-1/2 border border-gray-200 rounded-[2.5rem] overflow-hidden">
                <thead className="bg-blue-600 text-white">
                  <tr>
                    <th className="p-3 border text-left">Payment Mode</th>
                    <th className="p-3 border text-left">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(paymentModes).map(([mode, amount]) => (
                    <tr key={mode} className="hover:bg-gray-50">
                      <td className="p-3 border text-center">
                        {mode && mode.charAt(0).toUpperCase() + mode.slice(1)}
                      </td>
                      <td className="p-3 border ">
                        <input
                          type="number"
                          placeholder="Enter Amount"
                          value={
                            amount === "" || amount === 0 ? "" : Number(amount)
                          }
                          onChange={(e) =>
                            handleAmountChange(
                              mode,
                              parseFloat(e.target.value) || "Enter Amount"
                            )
                          }
                          className="w-full border text-center border-gray-300 rounded-full px-4 py-2"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="bg-blue-50 font-semibold">
                    <td className="p-3 border text-blue-700 text-left">
                      Total Payment
                    </td>
                    <td className="p-3 border text-blue-700">
                      Rs {final_price}
                    </td>
                  </tr>
                </tfoot>
              </table>
              {totalPayment !== final_price && (
                <p className="mt-2 text-red-600 font-medium">
                  Error: Payment total ({totalPayment.toFixed(2)}) does not
                  match the Grand Total ({final_price.toFixed(2)})!
                </p>
              )}
            </div>
          )}

          <div className="flex items-center justify-center mt-8 gap-4">
            <button
              type="submit"
              // onClick={() => handlePrint("thermal")}
              disabled={
                totalPayment !== final_price || loading || invoiceGenerated
              }
              className={`py-2 px-12 bg-blue-500 text-xl text-white font-semibold rounded-[2.5rem] ${
                totalPayment !== final_price
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : isEditMode ? (
                "Update Final Invoice"
              ) : (
                "Generate Final Invoice"
              )}
            </button>
          </div>
        </form>
      </div>
      {showPopup && (
        <Popup
          message={popupMessage}
          onClose={() => {
            setShowPopup(false);
            navigate(`/${sname}/${branchName}/dashboard`);
          }}
        />
      )}
      {showWhatsappConfirmation && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 backdrop-blur-sm">
          <div className="bg-gray-50 rounded-xl p-6 w-full max-w-md shadow-xl border border-gray-200">
            <div className="text-center mb-5">
              {/* Icon for visual appeal - you can replace with your own icon */}
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-blue-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                  />
                </svg>
              </div>

              <h3 className="text-xl font-semibold text-gray-800 mb-1">
                Share Invoice on WhatsApp
              </h3>
              <p className="text-gray-600">
                Confirm to send invoice to{" "}
                <span className="font-medium text-gray-800">
                  {customer_name}
                </span>
              </p>
            </div>

            <div className="flex justify-center space-x-4 mt-6">
              <button
                onClick={() => handleWhatsappConfirmation(false)}
                className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={() => handleWhatsappConfirmation(true)}
                className="px-5 py-2.5 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 shadow-sm"
              >
                Share Now
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Invoice;
